import { getWithAuth } from '../../Basic/HttpService';

export const getAllDriverDash = async () => {
    let res = await getWithAuth(`DriverDashboard`);
    return res;
};
